import ratgeberArticlesData from "./ratgeberArticles.json";

export const ratgeberArticles = ratgeberArticlesData;

export const getRatgeberArticle = (slug) =>
  ratgeberArticles.find((article) => article.slug === slug);

const tokenizeArticle = (article) =>
  [
    article.slug,
    article.title,
    article.category,
    article.description,
    article.excerpt,
    ...(article.keywords || []),
    ...(article.seoKeywords || []),
  ]
    .join(" ")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ß/g, "ss")
    .replace(/[^a-z0-9äöüß-]+/gi, " ")
    .split(/\s+/)
    .filter((token) => token.length > 2);

const getRelatedScore = (article, candidate) => {
  const articleTokens = new Set(tokenizeArticle(article));
  const candidateTokens = new Set(tokenizeArticle(candidate));
  const sharedTokenScore = [...candidateTokens].filter((token) => articleTokens.has(token)).length;
  const categoryScore = candidate.category === article.category ? 12 : 0;
  const regionalScore = [
    "magdeburg",
    "sachsen-anhalt",
    "mitteldeutschland",
    "freistaat",
    "sachsen",
    "thueringen",
    "thuringen",
    "niedersachsen",
    "brandenburg",
  ].filter(
    (token) => articleTokens.has(token) && candidateTokens.has(token),
  ).length * 8;
  const intentScore = [
    "batteriespeicher",
    "bess",
    "kleinspeicher",
    "dach",
    "flaeche",
    "flache",
    "fläche",
    "grundstueck",
    "grundstuck",
    "grundstück",
    "land",
    "verpachten",
    "vermieten",
    "solar",
    "pv",
    "solarpark",
    "photovoltaik",
  ].filter((token) => articleTokens.has(token) && candidateTokens.has(token)).length * 5;

  return categoryScore + regionalScore + intentScore + sharedTokenScore;
};

export const getRelatedRatgeberArticles = (article, limit = 4) =>
  ratgeberArticles
    .filter((candidate) => candidate.slug !== article.slug)
    .map((candidate, index) => ({
      candidate,
      index,
      score: getRelatedScore(article, candidate),
    }))
    .sort((a, b) => b.score - a.score || a.index - b.index)
    .slice(0, limit)
    .map(({ candidate }) => candidate);
